import * as React from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Box,
  Typography,
  Container,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Logo from "../../Assets/Logo.png";
import { useUsuario } from "../../Hooks/UsuarioHook";
import { useNavigate } from "react-router-dom";
import { app_base_url } from "../../Utils/Urls";
import { useEntidade } from "../../Hooks/EntidadeHook";
import { useUsuarioPrefeitura } from "../../Hooks/UsuarioPrefeituraHook";

const defaultTheme = createTheme();

interface Props {
  prefeitura?: boolean;
}

export function SignIn({ prefeitura }: Props) {
  const { login } = useUsuario();
  const usuarioPrefeitura = useUsuarioPrefeitura();
  const { entidade } = useEntidade();
  const navigate = useNavigate();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();
  const data = new FormData(event.currentTarget);
  let cpf = data.get("cpf")?.toString();
  const senha = data.get("senha")?.toString();

  if (cpf && senha) {
    // Verifica se a URL contém "/prefeitura" para decidir se limpa ou não
    const isPrefeitura = window.location.href.includes("/prefeitura");

    if (!isPrefeitura) {
      cpf = cpf.replace(/\D/g, ""); // Remove caracteres não numéricos apenas para empresa
    }

    isPrefeitura ? usuarioPrefeitura.login(cpf, senha) : login(cpf, senha);
  }
};

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 3,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#fff",
          }}
        >
          <img src={Logo} style={{ width: "140px", marginBottom: 16 }} />

          <Typography component="h1" variant="h5" gutterBottom>
            {prefeitura ? "ACESSAR MÓDULO PREFEITURA" : "ACESSAR SISTEMA"}
          </Typography>

          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1, width: "100%" }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="cpf"
              label={
                window.location.href.indexOf("/prefeitura") !== -1
                  ? "USUÁRIO"
                  : "CPF"
              }
              name="cpf"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="senha"
              label="SENHA"
              type="password"
              id="senha"
              autoComplete="current-password"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              ENTRAR
            </Button>

            {/* <Grid container justifyContent="space-between"> */}
                 <Box mt={4} textAlign="center" >
                <Link 
                  variant="h6"
                  onClick={() => {
                    navigate(
                      `${app_base_url}/${entidade.banco}/${prefeitura ? "" : "prefeitura"
                      }`
                    );
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {prefeitura
                    ? "logar como empresa"
                    : "logar como prefeitura"}
                </Link>
              </Box>
            {/* </Grid> */}

            <Box mt={4} textAlign="center">
              <Link
                variant="h6"
                color="primary"
                 onClick={() => {
                    navigate(
                      `${app_base_url}/${entidade.banco}/nao-emito-nota-fiscal`
                    );
                  }}
                style={{ cursor: "pointer", fontWeight: "bold" }}
              >
                Não emite nota fiscal em {entidade?.titulo?.replace("Prefeitura -", "")}?
              </Link>
            </Box>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
